// Otto Repricer Service API calls
import axios from "axios";

const MULTI_BASE_URL = import.meta.env.VITE_MULTI_API_URL || "/api/v1/multi";

// Create axios instance for Otto service
const multiApiClient = axios.create({
  baseURL: MULTI_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
multiApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Health check
export const ottoHealthApi = {
  healthCheck: () => multiApiClient.get("/health"),
};

export default multiApiClient;
